import { Alert } from 'react-bootstrap'
import { IValidation } from './models/validation';

interface IProps {
    data: IValidation
}

const Validation = (props: IProps) => {
    const { subject, message, centers, positions, receiveEmailOption, calendarInvite } = props.data;

    return (
        <Alert bsStyle='danger'>
            <div style={{ marginBottom: 10 }}>The following items need your attention:</div>

            <ul>
                {subject == false && (
                    <li>Subject is required</li>
                )}

                {message == false && (
                    <li>Message is required</li>
                )}

                {centers == false && (
                    <li>One or more centers must be selected</li>
                )}

                {(positions == false || receiveEmailOption == false) && (
                    <li>One or more positions must be selected or a recipient option must be selected</li>
                )}

                {calendarInvite == false && (
                    <li>Calendar Invite
                        <ul>
                            <li>Start time is required</li>
                            <li>End time is required</li>
                            <li>Start time must be prior to end time</li>
                            <li>Start time and End time must be in the future</li>
                        </ul>
                    </li>
                )}
            </ul>
        </Alert>
    );
}

export default Validation;